export default "__VITE_ASSET__DG_VXjP6__"